export const Constants = {
  Guid: {
    Empty: "00000000-0000-0000-0000-000000000000",
  },
  UserRoles: {
    Administrator: "Administrator",
    User: "User",
  },
  EmailLangPreference: {
    English: "en",
    Spanish: "es",
  },
  LogAction: {
    Created: "Created",
    Changed: "Changed",
    Added: "Added",
    Removed: "Removed",
    Transferred: "Transferred",
    Rolledover: "Rolledover",
    CreatedFromRollover: "CreatedFromRollover",
    ChangedInBulk: "ChangedInBulk",
    AddedInBulk: "AddedInBulk",
    RemovedInBulk: "RemovedInBulk",
  },
  ReactQuery: {
    /**
     * Subscribe to a query from a nested component without triggering retries or refetches.
     * Useful for subscribing to updates on data that is fetched in a parent component.
     */
    subscribeOnly: {
      subscribed: true,
      retry: false,
      retryOnMount: false,
      retryDelay: "Infinity",
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      notifyOnChangeProps: ["data"]
    }
  }
};
